//文字コードはutf-8

/* IR資料リスト（決算短信・適時開示・株主総会等の共通処理）
========================================================*/
export function initIrList() {
    var $ = jQuery;
    var moment = window.moment;

    var splitData = {};
    var pageTagId = '';
    var pageTagLabel = '';

    function makeData(items) {
        items = items || [];
        return {
            items: items,
            length: items.length
        };
    }

    function checkData(data) {
        if (data && $.isArray(data.items)) {
            return makeData(data.items.slice());
        }
        return makeData([]);
    }

    function decodeEntities(value) {
        if (value == null) return '';
        return $('<div/>').html(String(value)).text();
    }

    function escapeHtml(value) {
        return decodeEntities(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function formatDate(value, format) {
        var date = moment(new Date(value));
        if (!date.isValid()) return '';
        return date.format(format);
    }

    function formatFileSize(size) {
        var units = ['Byte', 'KB', 'MB', 'GB'];
        var unitIndex = 0;
        var parsedSize = parseInt(size, 10);

        if (!parsedSize) return '';

        while (parsedSize >= 1024 && unitIndex < units.length - 1) {
            parsedSize = parsedSize / 1024;
            unitIndex++;
        }

        parsedSize = unitIndex >= 2 ? Math.round(parsedSize * 10) / 10 : Math.round(parsedSize);
        return parsedSize + units[unitIndex];
    }

    function formatFileInfo(file) {
        if (!file) return '';

        var size = formatFileSize(file.size);
        var page = parseInt(file.page, 10);
        var pageText = page ? '/' + page + 'P' : '';

        return size ? '（' + size + pageText + '）' : '';
    }

    function findFile(files, fileType) {
        var result = null;

        if (!$.isArray(files)) return null;

        $.each(files, function (_, file) {
            if (file.type === fileType) {
                result = file;
                return false;
            }
        });

        return result || files[0] || null;
    }

    function isPdfUrl(url) {
        return /\.pdf(?:[?#].*)?$/i.test(url);
    }

    function isExternalUrl(url) {
        var parsedUrl;

        try {
            parsedUrl = new URL(url, window.location.href);
        } catch (error) {
            return false;
        }

        return parsedUrl.hostname !== window.location.hostname;
    }

    function isNewDate(value) {
        var date = moment(new Date(value));
        if (!date.isValid()) return false;
        return moment().diff(date, 'days') < 30;
    }

    function getPeriodList(split) {
        var periods = [];

        $.each(split, function (period) {
            periods.push(period);
        });

        periods.sort(function (a, b) {
            return parseInt(b, 10) - parseInt(a, 10);
        });

        return {
            items: $.map(periods, function (period) {
                return {
                    key: period
                };
            })
        };
    }

    function renderError() {
        $('[data-doctype-group]').html('<p class="modIRNewsMessage modIRNewsMessage--error">取得に失敗しました。時間をおいて再度お試しください。</p>');
    }

    function renderSections(data) {
        var xj = window.IR_XJ;

        $('[data-doctype-group]').each(function () {
            var $section = $(this);
            var groupKey = $section.data('doctypeGroup');
            var doctypes = (window.IR_CONFIG.groupCode[groupKey] || []);
            var filteredData = xj ? xj.filterData(data, doctypes) : makeData([]);

            pageTagId = $section.data('tagId') != null ? String($section.data('tagId')) : '';
            pageTagLabel = $section.data('tagLabel') != null ? String($section.data('tagLabel')) : (groupKey || '');

            $section.html($('#tpl-list').render(filteredData));
        });
    }

    function switchList() {
        var selectedPeriod = $('#intervalMenu select').val();
        var periodData = splitData[selectedPeriod] || makeData([]);

        renderSections(periodData);
    }

    function registerTemplateTools() {
        $.views.converters({
            date: function (value) {
                var format = this.tagCtx.props.format || 'YYYY年M月D日';
                return formatDate(value, format);
            },
            link: function (files) {
                var props = this.tagCtx.props;
                var file = findFile(files, props.fileType);
                var title = props.text || '';
                var dateTime = formatDate(props.publishDate, 'YYYY-MM-DD');
                var dateText = formatDate(props.publishDate, 'YYYY.MM.DD');
                var fileInfo = formatFileInfo(file);
                var url = file && file.url ? encodeURI(file.url) : '';
                var tagName = url ? 'a' : 'span';
                var classes = ['modListNews__item__link'];
                var attrs = '';
                var newHtml = isNewDate(props.publishDate) ? '<span class="new">NEW</span>' : '';
                var tagHtml = pageTagLabel
                    ? '<span class="tag irCat irCat_' + escapeHtml(pageTagId) + '">' + escapeHtml(pageTagLabel) + '</span>'
                    : '';

                if (url) {
                    attrs += ' href="' + escapeHtml(url) + '"';
                    if (isPdfUrl(url)) {
                        classes.push('pdf');
                        classes.push('modListNews__item__link--pdf');
                    } else if (isExternalUrl(url)) {
                        classes.push('blank');
                        classes.push('modListNews__item__link--external');
                    }
                    if (isPdfUrl(url) || isExternalUrl(url)) {
                        attrs += ' target="_blank" rel="noopener noreferrer"';
                    }
                } else {
                    attrs += ' aria-disabled="true"';
                    classes.push('irNewsLink--disabled');
                }

                attrs += ' class="' + classes.join(' ') + '"';

                return '<' + tagName + attrs + '>' +
                    '<div class="heading"><h3>' + escapeHtml(title) +
                    (fileInfo ? '<span class="unit">' + escapeHtml(fileInfo) + '</span>' : '') +
                    '</h3></div>' +
                    '<time class="date" datetime="' + escapeHtml(dateTime) + '">' + escapeHtml(dateText) + '</time>' +
                    tagHtml +
                    newHtml +
                    '</' + tagName + '>';
            }
        });
    }

    function collectDoctypes($sections) {
        var doctypeSet = {};

        $sections.each(function () {
            var groupKey = $(this).data('doctypeGroup');
            var doctypes = window.IR_CONFIG.groupCode[groupKey];

            if ($.isArray(doctypes)) {
                $.each(doctypes, function (_, code) {
                    doctypeSet[code] = true;
                });
            }
        });

        return $.map(doctypeSet, function (_, code) {
            return parseInt(code, 10);
        });
    }

    function splitByInterval(response, $sections) {
        var type = $sections.first().data('intervalType') || 'ad';
        var addMonths = $sections.first().data('intervalMonths');
        var addDays = $sections.first().data('intervalDays');

        if (type === 'year') {
            return window.IR_XJ.splitDataInterval(response);
        }

        return window.IR_XJ.splitDataInterval(
            response,
            type,
            addMonths != null ? parseInt(addMonths, 10) : 7,
            addDays != null ? parseInt(addDays, 10) : 3
        );
    }

    function usesInterval($sections) {
        return ($sections.first().data('intervalType') || 'ad') !== 'none';
    }

    var $sections = $('[data-doctype-group]');
    var xj = window.IR_XJ;
    var allDoctypes;

    if (!$sections.length || !$('#tpl-list').length) return;

    if (!window.IR_CONFIG || !xj || !$.views || !moment) {
        renderError();
        return;
    }

    allDoctypes = collectDoctypes($sections);

    if (!allDoctypes.length) {
        renderError();
        return;
    }

    registerTemplateTools();

    $('#intervalMenu').on('change', 'select', switchList);

    xj.getList({
        len: 10000,
        doctype: allDoctypes
    }).done(function (response) {
        var periodList;

        if (!usesInterval($sections)) {
            renderSections(response);
            return;
        }

        splitData = splitByInterval(response, $sections);
        periodList = getPeriodList(splitData);

        $('#intervalMenu').html($('#tpl-intervalMenu').render(periodList));
        switchList();
    }).fail(renderError);
}
